// Курс базовой валюты филиала к валюте кассы — зеркало серверного ExchangeRate.get_rate
// (rentalman-api): прямая пара «базовая → валюта кассы» или обратная «валюта кассы → базовая»
// (тогда курс 1 / rate); валюта совпала с базовой — 1. Курса нет — null: платёж в такую
// валюту сервер отклонит с кодом exchange_rate_missing (422), подставлять 1:1 нельзя.
//
// Сервер хранит приведённую сумму как rated_sum = sum / rate, то есть rate — сколько единиц
// валюты кассы в одной базовой. Отсюда: из базовой в валюту кассы — умножить, обратно — делить.
//
// Раньше диалоги искали курс по одной target_currency_id: обратную пару не видели вовсе и
// могли взять пару с чужой базовой валютой, если у компании их несколько.
export function rateToBase(exchangeRates, baseCurrencyId, currencyId) {
  if (currencyId == null || baseCurrencyId == null) return 1;
  if (String(currencyId) === String(baseCurrencyId)) return 1;
  const rates = Array.isArray(exchangeRates) ? exchangeRates : [];
  const same = (a, b) => String(a) === String(b);
  const direct = rates.find((r) => same(r.base_currency_id, baseCurrencyId) && same(r.target_currency_id, currencyId));
  const directRate = direct && parseFloat(direct.rate);
  if (directRate > 0) return directRate;
  const inverse = rates.find((r) => same(r.base_currency_id, currencyId) && same(r.target_currency_id, baseCurrencyId));
  const inverseRate = inverse && parseFloat(inverse.rate);
  if (inverseRate > 0) return 1 / inverseRate;
  return null;
}

const round2 = (value) => Math.round(value * 100) / 100;

// Сумма в базовой валюте → в валюте кассы (сколько к оплате в выбранной кассе).
export function fromBase(amount, rate) {
  const value = parseFloat(amount);
  if (!Number.isFinite(value) || !(rate > 0)) return null;
  return round2(value * rate);
}

// Сумма в валюте кассы → в базовой валюте (то, что сервер запишет в rated_sum).
export function toBase(amount, rate) {
  const value = parseFloat(amount);
  if (!Number.isFinite(value) || !(rate > 0)) return null;
  return round2(value / rate);
}
